import { render, staticRenderFns } from "./CPagination.vue?vue&type=template&id=bacf251c&scoped=true"
import script from "./CPagination.vue?vue&type=script&lang=js"
export * from "./CPagination.vue?vue&type=script&lang=js"
import style0 from "./CPagination.vue?vue&type=style&index=0&id=bacf251c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacf251c",
  null
  
)

export default component.exports